import { makeStyles } from "@material-ui/styles";

const lineScoreStyles = makeStyles((theme) => ({
	period: {
		width: 60
	},
	header: {
		"& th": {
			fontSize: 12,
			letterSpacing: 0.5,
			textTransform: "uppercase",
			lineHeight: "40px"
		}
	},
	row: {
		"& td": {
			fontSize: 16,
			fontWeight: 500,
			lineHeight: "40px"
		},
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover
		}
	}
}));

export default lineScoreStyles;
